import type { ReactNode } from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

// Portal target created by the legacy idv layout's Content component.
// Portaling here ensures the button is always visible at the bottom of
// the layout (above the footer), eliminating scroll-flow gaps on mobile.
const BOTTOM_ACTION_BOX_ID = 'bottom-action-box';
const StickyBottomBox = ({
  children
}: {
  children: ReactNode;
}) => {
  const ref = useRef<Element | null>(null);
  const [mounted, setMounted] = useState(false);
  useLayoutEffect(() => {
    const element = document.getElementById(BOTTOM_ACTION_BOX_ID);
    if (element) {
      while (element.firstChild) {
        element.firstChild.remove();
      }
    }
    ref.current = element;
    setMounted(true);
  }, []);
  if (!mounted) return null;
  if (ref.current) {
    return createPortal(<div className="flex flex-col p-4 bg-primary">{children}</div>, ref.current);
  }

  // Fallback when not rendered inside the legacy idv layout (e.g. Storybook)
  return <div className="w-full sticky bottom-0 bg-primary pt-5 pb-7 px-5">{children}</div>;
};
export default StickyBottomBox;